import { Button } from '@/components/ui/button';

interface Props {
    onEnable: () => void;
    onDismiss: () => void;
}

export default function NotificationPromptDock({ onEnable, onDismiss }: Props) {
    return (
        <div className="flex flex-wrap items-center gap-3 bg-white dark:bg-sidebar-accent composer-shadow mb-2 px-4 py-3 border rounded-xl">
            <div className="flex-1 basis-56 min-w-0">
                <div className="font-medium text-title">
                    Get notified when the response is ready?
                </div>
                <div className="text-muted-foreground text-subtitle">
                    You&apos;ll get a browser notification if you switch to
                    another tab, and when the assistant has a question.
                </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
                <Button
                    variant="ghost"
                    onClick={onDismiss}
                    className="text-muted-foreground hover:text-foreground"
                >
                    No thanks
                </Button>
                <Button onClick={onEnable}>Notify me</Button>
            </div>
        </div>
    );
}
